<template>
  <v-container>
    <teacher-form
      :back-btn="false"
      v-if="!loading"
      v-model="entity"
      @save="save"
    ></teacher-form>
    <loading-page v-if="loading"></loading-page>
  </v-container>
</template>
<script>
import auth from "@/common/auth";
import TeacherForm from "@/mockups/teachers/components/TeacherForm";
import LoadingPage from "@/components/loading-page/LoadingPage.vue";
import { deleteTempFile } from "@/common/file-utils";
import RepositoryFactory from "@/repositories/RepositoryFactory";

const TeacherEntityRepository = RepositoryFactory.get(
  "TeacherEntityRepository"
);
export default {
  name: "TeacherGuestForm",
  components: { TeacherForm, LoadingPage },
  data() {
    return {
      entity: {
        name: auth.getUser().firstName,
        surname: auth.getUser().lastName,
        mainEmail: auth.getUser().email,
        langKey: auth.getUser().langKey.toLowerCase(),
      },
      loading: false,
    };
  },
  beforeDestroy() {
    deleteTempFile(this.entity, "photo");
  },
  methods: {
    async save() {
      this.loading = true;
      this.checkSecondaryEmail();
      TeacherEntityRepository.save(this.entity)
        .then(() => {
          this.entity.photo = null;
          auth.reloadUserData().finally(() => {
            this.$router.goToUserHome();
          });
        })
        .catch(() => this.$log.debug("Error saving teacher: " + this.entity))
        .finally(() => (this.loading = false));
    },
    checkSecondaryEmail() {
      this.entity.secondaryEmail =
        this.entity.secondaryEmail === ""
          ? undefined
          : this.entity.secondaryEmail;
    },
  },
};
</script>
